import { mediaQuery } from '../helpers';

export default class FooterMenu {
	constructor(root) {
		this.root = root;

		if (!mediaQuery('sm') || !root) {
			return false;
		}

		const title = root.querySelector('.widget-title');
		const menu = root.querySelector('.menu');

		const details = document.createElement('details');
		const detailsContent = document.createElement('div');
		const summary = document.createElement('summary');

		details.setAttribute('class', 'bg-white menu !mb-0 [&_li]:list-none');
		detailsContent.innerHTML = menu?.innerHTML;
		detailsContent.classList.add('pt-0');
		summary.textContent = title?.textContent;
		summary.setAttribute('class', '!mb-0');

		details.appendChild(summary);
		details.appendChild(detailsContent);

		root.innerHTML = '';
		root.appendChild(details);
	}
}
